class EmailObfuscator {

	constructor(){
		this._init();
	}

	_init(){
	  document.addEventListener('DOMContentLoaded', (event) => {

	    jQuery('.email-obfuscator').map(function(){

	        let encodedString = jQuery(this).text();
	        let decodedString = encodedString.replace(/[a-zA-Z]/g, function(c){
	          return String.fromCharCode((c <= "Z" ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26);
	        });

	        jQuery(this).text(decodedString);
	    
	    });

	    jQuery('.email-obfuscator-mailto').map(function(){

	        let encodedString = jQuery(this).attr('href');
	        let decodedString = encodedString.replace(/[a-zA-Z]/g, function(c){
	          return String.fromCharCode((c <= "Z" ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26);
	        });

	        jQuery(this).attr('href','mailto: '+decodedString);
	    
	    });

	  });
	}

}

export let emailObfuscator = new EmailObfuscator();